var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAisin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1700,
    height: 1200,
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1700 1200",
    style: {
      enableBackground: "new 0 0 1700 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001A72",
    d: "M823.5,478.1c-30.3,0-62.5,2.8-72.9,43.5s16.1,57.7,41.6,75.7l108.8,72.9c7.6,4.7,4.7,16.1-3.8,16.1H723.2 c-9.5,0-16.1,4.7-18.9,15.1l-5.7,21.8h208.2c30.3,0,62.5-5.7,72.9-46.4c10.4-40.7-16.1-57.7-41.6-75.7l-106-72.9 c-9.5-6.6-6.6-18.9,4.7-18.9h138.1c36.9,0,41.6-18,45.4-32.2H823.5V478.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001A72",
    d: "M1164.1,722.2l63.4-245.1c0,0,53,0,148.6,0c94.6,0,126.8,34.1,105,119.2L1449,722.2h-80.4l32.2-125.8 c15.1-59.6,7.6-87.1-32.2-87.1s-67.2,0-67.2,0l-54.9,212.9C1246.5,722.2,1164.1,722.2,1164.1,722.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001A72",
    d: "M556.7,722.2l54.9-211c7.6-29.3,24.6-34.1,43.5-34.1h63.4l-0.9,3.8c0,0-18,2.8-24.6,28.4l-54.9,212.9 C638.1,722.2,556.7,722.2,556.7,722.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001A72",
    d: "M1022.2,722.2l54.9-211c7.6-29.3,24.6-34.1,43.5-34.1h63.4l-0.9,3.8c0,0-18,2.8-24.6,28.4l-54.9,212.9 C1103.6,722.2,1022.2,722.2,1022.2,722.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001A72",
    d: "M410,478.1c-70,0-141,19.9-166.5,119.2l-33.1,124.9h80.4l4.7-18c14.2-54.9,141-71,141-71l-22.7,88.9h80.4 l63.4-245.1H410V478.1z M442.2,611.5l-126.8,15.1l7.6-30.3c15.1-59.6,39.7-87.1,93.7-87.1h51.1L442.2,611.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAisin);
export default __webpack_public_path__ + "static/media/aisin.2276c16d615bafef8a113e1406878c4e.svg";
export { ForwardRef as ReactComponent };